import { Component, Input, OnInit } from '@angular/core';
import { FilterAdvanced } from 'projects/core/src/include/structures';
import { DossierPhasesService } from '../../../services/dossierphases.service';
import { DossierField, DossierPhase, FilterDossier } from '../../../dossier';

@Component({
  selector: 'app-dossierfilter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.css'
})
export class FilterComponent implements OnInit {
  @Input()
  filters:FilterDossier[]=[]

  @Input()
  id_type:number=0;

  dossierPhases:DossierPhase[]=[];

  constructor(private dossierPhasesService:DossierPhasesService){

  }

  ngOnInit(): void {
    this.dossierPhasesService.getPhasesByType(this.id_type).subscribe((res)=>{

      for(let p of res){
        for(let s of p.sections){
          for(let f of s.fields){
            if(f.type=="select" && f.params!=null && f.params!=""){
              if(typeof f.params=="string")
                f.params=JSON.parse(f.params);
            }
          }
        }
      }
      this.dossierPhases=res;
    }
  
  )
  }
  


   addFilter():void{
    let c:FilterDossier=new FilterDossier();
    c.condition="ugual";
    c.nextCondition="AND";
    if(this.filters==undefined)
        this.filters=[]

    this.filters.push(c);

    

  }

  removeFilter(c:FilterDossier):void{
    for(let i=0;i<this.filters.length;i++){
      if(this.filters[i]==c){
        this.filters.splice(i,1);
        return;
      }

    }
  }


}
